export default function Edit() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.5"
        y1="13.4998"
        x2="11.9536"
        y2="13.4998"
        stroke="#2D4040"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6537 2.19866C13.2137 2.93001 13.0749 3.97689 12.3435 4.53692L4.65112 10.4273L4.65135 10.4276L1.23278 10.9447L2.62302 7.77979L2.62259 7.77923L10.3154 1.88845C11.0468 1.32842 12.0937 1.4673 12.6537 2.19866Z"
        className="fillStroke"
        fill="#2D4040"
      />
    </svg>
  )
}
